


// // src/Components/Book.jsx
// import React, { useEffect, useState } from "react";
// import "./Book.css";
// import { db } from "./firebase";
// import {
//   collection,
//   query,
//   orderBy,
//   onSnapshot,
// } from "firebase/firestore";
// import { useNavigate } from "react-router-dom";

// const BookCard = () => {
//   const [books, setBooks] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [search, setSearch] = useState("");

//   // 🔐 Premium emails from Firestore
//   const [premiumEmails, setPremiumEmails] = useState([]);

//   const navigate = useNavigate();

//   // 🔹 Subscription flag (future use)
//   const isSubscribed = false;

//   // 🔹 Logged-in user
//   const user = JSON.parse(localStorage.getItem("user"));
//   const userEmail = user?.email?.trim().toLowerCase() || null;

//   /* ================= LOAD PREMIUM EMAILS ================= */
//   useEffect(() => {
//     const unsub = onSnapshot(
//       collection(db, "premiumEmails"),
//       (snapshot) => {
//         const emails = snapshot.docs
//           .map((doc) => doc.data().email)
//           .filter(Boolean)
//           .map((e) => e.trim().toLowerCase());

//         setPremiumEmails(emails);
//       },
//       (err) => console.error("Error loading premium emails:", err)
//     );

//     return () => unsub();
//   }, []);

//   // 🔐 FINAL premium access logic
//   const hasPremiumAccess =
//     isSubscribed || (userEmail && premiumEmails.includes(userEmail));

//   /* ================= LOAD BOOKS ================= */
//   useEffect(() => {
//     const q = query(collection(db, "books"), orderBy("createdAt", "desc"));

//     const unsub = onSnapshot(
//       q,
//       (snapshot) => {
//         const list = snapshot.docs.map((doc) => ({
//           id: doc.id,
//           ...doc.data(),
//         }));
//         setBooks(list);
//         setLoading(false);
//       },
//       (err) => {
//         console.error("Error fetching books:", err);
//         setLoading(false);
//       }
//     );

//     return () => unsub();
//   }, []);

//   /* ================= SEARCH ================= */
//   const filteredBooks = books.filter((book) => {
//     const term = search.trim().toLowerCase();
//     if (!term) return true;

//     return (
//       (book.title || "").toLowerCase().includes(term) ||
//       (book.author || "").toLowerCase().includes(term)
//     );
//   });

//   const handlePreview = (book) => {
//     if (!book?.pdfUrl) return;
//     window.open(book.pdfUrl, "_blank", "noopener,noreferrer");
//   };

//   const handleDownloadPdf = (book) => {
//     if (!book?.pdfUrl) return;
//     const link = document.createElement("a");
//     link.href = book.pdfUrl;
//     link.target = "_blank";
//     link.rel = "noopener noreferrer";
//     link.download = (book.title || "book") + ".pdf";
//     document.body.appendChild(link);
//     link.click();
//     document.body.removeChild(link);
//   };

//   const goToSubscription = () => {
//     navigate("/membership");
//   };

//   return (
//     <div className="book-container">
//       <h2>📚 Featured Library Books</h2>

//       {hasPremiumAccess && (
//         <p style={{ color: "green", fontWeight: "bold" }}>
//           ✅ Premium Access Enabled
//         </p>
//       )}

//       <input
//         type="text"
//         placeholder="Search by title or author..."
//         value={search}
//         onChange={(e) => setSearch(e.target.value)}
//         className="search-input"
//       />

//       {loading && <p>Loading books…</p>}

//       {!loading && filteredBooks.length === 0 && (
//         <p>No books found. Try uploading one from the Admin panel.</p>
//       )}

//       <div className="book-grid">
//         {filteredBooks.map((book, index) => {
//           const isWithinFreePreview = index < 5;

//           // 🔐 FINAL LOCK LOGIC
//           const isLocked = !hasPremiumAccess && !isWithinFreePreview;

//           return (
//             <div
//               className={`book-card ${isLocked ? "book-card-locked" : ""}`}
//               key={book.id}
//             >
//               <div className="book-cover-wrapper">
//                 {isLocked && <div className="lock-badge">🔒</div>}
//                 <img
//                   src={book.coverUrl || "/logo.png"}
//                   alt={book.title}
//                   className="book-cover-img"
//                 />
//               </div>

//               <div className="book-info">
//                 <h3 title={book.title}>{book.title}</h3>
//                 {book.author && (
//                   <p className="book-author">by {book.author}</p>
//                 )}

//                 {book.pdfUrl && (
//                   <div className="book-actions">
//                     {!isLocked ? (
//                       <>
//                         <button
//                           className="preview-btn"
//                           onClick={() => handlePreview(book)}
//                         >
//                           View
//                         </button>

//                         <button
//                           className="download-btn"
//                           onClick={() => handleDownloadPdf(book)}
//                         >
//                           Download PDF
//                         </button>
//                       </>
//                     ) : (
//                       <button
//                         className="subscribe-btn"
//                         onClick={goToSubscription}
//                       >
//                         Subscribe to unlock
//                       </button>
//                     )}
//                   </div>
//                 )}
//               </div>
//             </div>
//           );
//         })}
//       </div>
//     </div>
//   );
// };

// export default BookCard;



//updation on the UI admin panel on 03-02-2025
// src/Components/Book.jsx
import React, { useEffect, useState } from "react";
import "./Book.css";
import { db } from "./firebase";
import {
  collection,
  query,
  orderBy,
  onSnapshot,
} from "firebase/firestore";
import { useNavigate } from "react-router-dom";

const BookCard = () => {
  const [books, setBooks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");

  // 🔹 Sort filter
  const [sortType, setSortType] = useState("latest");

  // 🔹 Free books (first 5 only)
  const [freeBookIds, setFreeBookIds] = useState([]);

  // 🔐 Premium users (email + username + allowedBookIds)
  const [premiumUsers, setPremiumUsers] = useState([]);

  const navigate = useNavigate();

  // 🔹 Logged-in user
  const user = JSON.parse(localStorage.getItem("user"));
  const userEmail = user?.email?.trim().toLowerCase() || null;

  /* ================= LOAD PREMIUM USERS ================= */
  useEffect(() => {
    const unsub = onSnapshot(
      collection(db, "premiumEmails"),
      (snapshot) => {
        const users = snapshot.docs.map((doc) => ({
          email: doc.data().email?.toLowerCase(),
          username: doc.data().username,
          allowedBookIds: doc.data().allowedBookIds || [],
        }));
        setPremiumUsers(users);
      },
      (err) => console.error("Error loading premium users:", err)
    );

    return () => unsub();
  }, []);

  // 🔐 Find current premium user
  const premiumUser = premiumUsers.find(
    (u) => u.email === userEmail
  );

  const hasPremiumAccess = !!premiumUser;

  /* ================= LOAD BOOKS ================= */
  useEffect(() => {
    const q = query(collection(db, "books"), orderBy("createdAt", "desc"));

    const unsub = onSnapshot(
      q,
      (snapshot) => {
        const list = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));

        setBooks(list);

        // First 5 books are free
        const firstFiveIds = list.slice(0, 5).map((b) => b.id);
        setFreeBookIds(firstFiveIds);

        setLoading(false);
      },
      (err) => {
        console.error("Error fetching books:", err);
        setLoading(false);
      }
    );

    return () => unsub();
  }, []);

  /* ================= FILTER + SORT ================= */
  const visibleBooks = books
    .filter((book) => {
      // 🔐 Premium user → ONLY allowed books
      if (hasPremiumAccess) {
        return premiumUser.allowedBookIds.includes(book.id);
      }

      // 👤 Normal user → show all (lock handled later)
      return true;
    })
    .filter((book) => {
      const term = search.trim().toLowerCase();
      if (!term) return true;

      return (
        (book.title || "").toLowerCase().includes(term) ||
        (book.author || "").toLowerCase().includes(term)
      );
    })
    .sort((a, b) => {
      if (sortType === "az") {
        return (a.title || "").localeCompare(b.title || "");
      }
      if (sortType === "za") {
        return (b.title || "").localeCompare(a.title || "");
      }
      return 0;
    });

  const handlePreview = (book) => {
    if (!book?.pdfUrl) return;
    window.open(book.pdfUrl, "_blank", "noopener,noreferrer");
  };

  const handleDownloadPdf = (book) => {
    if (!book?.pdfUrl) return;
    const link = document.createElement("a");
    link.href = book.pdfUrl;
    link.target = "_blank";
    link.rel = "noopener noreferrer";
    link.download = (book.title || "book") + ".pdf";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const goToSubscription = () => {
    navigate("/membership");
  };

  return (
    <div className="book-container">
      <h2>📚 Featured Library Books</h2>

      {/* ✅ PREMIUM MESSAGE */}
      {hasPremiumAccess && premiumUser && (
        <p style={{ color: "green", fontWeight: "bold" }}>
          ✅ Premium Access Enabled for{" "}
          <span style={{ textTransform: "capitalize" }}>
            {premiumUser.username}
          </span>
        </p>
      )}

      {/* 🔍 SEARCH */}
      <input
        type="text"
        placeholder="Search by title or author..."
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        className="search-input"
      />

      {/* 🔽 SORT */}
      <div className="filter-bar">
        <select
          value={sortType}
          onChange={(e) => setSortType(e.target.value)}
          className="filter-select"
        >
          <option value="latest">Latest</option>
          <option value="az">Name: A → Z</option>
          <option value="za">Name: Z → A</option>
        </select>
      </div>

      {loading && <p>Loading books…</p>}

      {!loading && visibleBooks.length === 0 && (
        <p>No books available for your account.</p>
      )}

      <div className="book-grid">
        {visibleBooks.map((book) => {
          const isFreeBook = freeBookIds.includes(book.id);
          const isLocked = !hasPremiumAccess && !isFreeBook;

          return (
            <div
              className={`book-card ${isLocked ? "book-card-locked" : ""}`}
              key={book.id}
            >
              <div className="book-cover-wrapper">
                {isLocked && <div className="lock-badge">🔒</div>}
                <img
                  src={book.coverUrl || "/logo.png"}
                  alt={book.title}
                  className="book-cover-img"
                />
              </div>

              <div className="book-info">
                <h3 title={book.title}>{book.title}</h3>
                {book.author && (
                  <p className="book-author">by {book.author}</p>
                )}

                {book.pdfUrl && (
                  <div className="book-actions">
                    {!isLocked ? (
                      <>
                        <button
                          className="preview-btn"
                          onClick={() => handlePreview(book)}
                        >
                          View
                        </button>

                        <button
                          className="download-btn"
                          onClick={() => handleDownloadPdf(book)}
                        >
                          Download PDF
                        </button>
                      </>
                    ) : (
                      <button
                        className="subscribe-btn"
                        onClick={goToSubscription}
                      >
                        Subscribe to unlock
                      </button>
                    )}
                  </div>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default BookCard;
